import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { User } from "./User";
import { InvoiceOrder } from "./InvoiceOrder";
import Role from "./Role";
import Model from "./Model";
export class Invoice extends Model {
  constructor() {
    super();
    _defineProperty(this, "Id", {
      fieldName: 'invoice_id',
      content: null
    });
    _defineProperty(this, "InvoiceId", {
      fieldName: 'invoice_id',
      content: null
    });
    _defineProperty(this, "InvoiceGeneratedBy", {
      fieldName: 'generated_by',
      model: User,
      content: null
    });
    _defineProperty(this, "InvoicePaymentID", {
      fieldName: 'invoice_payment_id',
      content: null
    });
    _defineProperty(this, "InvoicePaymentMethod", {
      fieldName: 'invoice_payment_method',
      content: null
    });
    _defineProperty(this, "InvoicePaymentStatus", {
      fieldName: 'invoice_payment_status',
      content: null
    });
    _defineProperty(this, "InvoicePaymentType", {
      fieldName: 'invoice_payment_type',
      content: null
    });
    _defineProperty(this, "InvoiceTotal", {
      fieldName: 'invoice_total',
      content: null
    });
    _defineProperty(this, "InvoiceDate", {
      fieldName: 'created_at',
      content: null
    });
    _defineProperty(this, "InvoiceIssuerID", {
      fieldName: 'issuer_id',
      content: null
    });
    _defineProperty(this, "InvoiceIssuer", {
      fieldName: 'issued_for',
      model: User,
      content: null
    });
    _defineProperty(this, "InvoiceInvoiceOrder", {
      fieldName: 'invoice_invoice_orders',
      model: InvoiceOrder,
      content: []
    });
    _defineProperty(this, "InvoiceAdvertiserTotal", {
      fieldName: 'invoice_advertiser_total',
      content: 0
    });
    _defineProperty(this, "InvoiceNetworkExpenses", {
      fieldName: 'network_expenses',
      content: 0
    });
    _defineProperty(this, "InvoicePaidAt", {
      fieldName: 'paid_at',
      content: null
    });
    _defineProperty(this, "InvoiceRemittedParty", {
      fieldName: 'remitted_party',
      model: User,
      content: null
    });
    _defineProperty(this, "issuedFor", {
      fieldName: 'issued_for',
      model: User,
      content: null
    });
    _defineProperty(this, "referrerCommission", {
      fieldName: 'referrer_commission',
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getIssuedForRole() {
    let issuedFor = this.getIssuedFor();
    return issuedFor instanceof User ? issuedFor.getRole() : null;
  }
  getIssuedForRoleName() {
    let role = this.getIssuedForRole();
    return role instanceof Role ? role.getName() : null;
  }
  isIssuedForWarehouse() {
    return this.getIssuedForRoleName() === Role.WAREHOUSE_ROLE;
  }
  getPaymentType() {
    return this.InvoicePaymentType.content;
  }
  isExpenses() {
    return this.getPaymentType() === Invoice.EXPENSES_TYPE;
  }
  getPaymentStatus() {
    return this.InvoicePaymentStatus.content;
  }
  isPaid() {
    return this.getPaymentStatus() === Invoice.PAID_STATUS;
  }
  getReferrerCommission() {
    return this.referrerCommission.content;
  }
  getCreatedAt() {
    return this.InvoiceDate.content;
  }
  getTotal() {
    return this.InvoiceTotal.content;
  }
  getGeneratedFor() {
    return this.issuedFor.content;
  }
  getIssuedFor() {
    return this.InvoiceIssuer.content;
  }
  getIssuedForName() {
    let issuedFor = this.getIssuedFor();
    return issuedFor instanceof User ? issuedFor.getName() : null;
  }
  getGeneratedForReferrer() {
    let generatedFor = this.getGeneratedFor();
    return generatedFor instanceof User ? generatedFor.getReferrer() : null;
  }
  getGeneratedForReferrerName() {
    let generatedForReferrer = this.getGeneratedForReferrer();
    return generatedForReferrer instanceof User ? generatedForReferrer.getName() : null;
  }
  getGeneratedForName() {
    let generatedFor = this.getGeneratedFor();
    return generatedFor instanceof User ? generatedFor.getName() : null;
  }
  static getPaidPartyBankDetails(invoice) {
    var _invoice$InvoiceRemit, _invoice$issuedFor;
    switch (invoice.InvoicePaymentType.content) {
      case Invoice.COMMISSION_TYPE:
      case Invoice.REMITTANCE_TYPE:
        return (_invoice$InvoiceRemit = invoice.InvoiceRemittedParty) === null || _invoice$InvoiceRemit === void 0 || (_invoice$InvoiceRemit = _invoice$InvoiceRemit.content) === null || _invoice$InvoiceRemit === void 0 || (_invoice$InvoiceRemit = _invoice$InvoiceRemit.UserBankDetails) === null || _invoice$InvoiceRemit === void 0 ? void 0 : _invoice$InvoiceRemit.content;
      default:
        return (_invoice$issuedFor = invoice.issuedFor) === null || _invoice$issuedFor === void 0 || (_invoice$issuedFor = _invoice$issuedFor.content) === null || _invoice$issuedFor === void 0 || (_invoice$issuedFor = _invoice$issuedFor.UserBankDetails) === null || _invoice$issuedFor === void 0 ? void 0 : _invoice$issuedFor.content;
    }
  }
  static getPaidPartyPayoneerDetails(invoice) {
    var _invoice$InvoiceRemit2, _invoice$issuedFor2;
    switch (invoice.InvoicePaymentType.content) {
      case Invoice.COMMISSION_TYPE:
      case Invoice.REMITTANCE_TYPE:
        return (_invoice$InvoiceRemit2 = invoice.InvoiceRemittedParty) === null || _invoice$InvoiceRemit2 === void 0 || (_invoice$InvoiceRemit2 = _invoice$InvoiceRemit2.content) === null || _invoice$InvoiceRemit2 === void 0 || (_invoice$InvoiceRemit2 = _invoice$InvoiceRemit2.UserBankPayoneer) === null || _invoice$InvoiceRemit2 === void 0 ? void 0 : _invoice$InvoiceRemit2.content;
      default:
        return (_invoice$issuedFor2 = invoice.issuedFor) === null || _invoice$issuedFor2 === void 0 || (_invoice$issuedFor2 = _invoice$issuedFor2.content) === null || _invoice$issuedFor2 === void 0 || (_invoice$issuedFor2 = _invoice$issuedFor2.UserBankPayoneer) === null || _invoice$issuedFor2 === void 0 ? void 0 : _invoice$issuedFor2.content;
    }
  }
  static getSelectedPaymentMethod(invoice, payment_method) {
    switch (payment_method !== null && payment_method !== void 0 ? payment_method : invoice.InvoicePaymentMethod.content) {
      case Invoice.BANK_TRANSFER:
        return Invoice.getPaidPartyBankDetails(invoice);
      case Invoice.PAYONEER:
        return Invoice.getPaidPartyPayoneerDetails(invoice);
    }
  }
}
_defineProperty(Invoice, "PAID_STATUS", 'paid');
_defineProperty(Invoice, "PENDING_STATUS", 'pending');
_defineProperty(Invoice, "NOT_APPLICABLE_STATUS", 'n-a');
_defineProperty(Invoice, "EXPENSES_TYPE", 'expenses');
_defineProperty(Invoice, "CHARGES_TYPE", 'charges');
_defineProperty(Invoice, "REMITTANCE_TYPE", 'remittance');
_defineProperty(Invoice, "COMMISSION_TYPE", 'commission');
_defineProperty(Invoice, "PAYOUT_TYPE", 'payout');
_defineProperty(Invoice, "REFERRER_PAYOUT_TYPE", 'referrer_payout');
_defineProperty(Invoice, "BANK_TRANSFER", 'bank-transfer');
_defineProperty(Invoice, "PAYONEER", 'payoneer');
export default Invoice;